"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initGlobalContext = exports.createGlobalStore = void 0;
const core_1 = require("../core");
const redux_1 = require("redux");
const redux_batched_actions_1 = require("redux-batched-actions");
const redux_thunk_1 = __importDefault(require("redux-thunk"));
const service_1 = require("../resource/service");
const subscribe_1 = require("../subscribe");
__exportStar(require("./selector"), exports);
__exportStar(require("./actions"), exports);
__exportStar(require("./connector"), exports);
__exportStar(require("./constant"), exports);
__exportStar(require("./slice/root"), exports);
const createGlobalStore = () => (0, redux_1.createStore)((0, redux_batched_actions_1.enableBatching)(core_1.Reducers.rootReducers), (0, redux_1.compose)((0, redux_1.applyMiddleware)(redux_thunk_1.default)));
exports.createGlobalStore = createGlobalStore;
/**
 * @description Initialize all the dependencies and data needed for the widget and create an environment that can run independently.
 * 1. Enables widget developers to develop widget directly without launching the main development environment.
 * 2. Allow the widget to be displayed independently from the datasheet (standalone page).
 */
const initGlobalContext = () => {
    const store = (0, exports.createGlobalStore)();
    const datasheetService = new service_1.ResourceService(store, e => alert(e.message));
    const unSubscribeDatasheetMap = (0, subscribe_1.subscribeDatasheetMap)(store, { instance: datasheetService });
    const unSubscribeWidgetMap = (0, subscribe_1.subscribeWidgetMap)(store, { instance: datasheetService });
    return {
        resourceService: datasheetService,
        globalStore: store,
        unSubscribe: () => {
            unSubscribeDatasheetMap();
            unSubscribeWidgetMap();
        },
    };
};
exports.initGlobalContext = initGlobalContext;
